export default __webpack_public_path__ + "static/media/check2-666561.8d45e557.svg";